<template>
  <div class="bg-white mt-6 rounded p-3">
    <div class="w-full flex flex-col md:flex-row justify-between items-center border-b py-5 mb-5">
      <div class="flex">
        <div class="w-32 h-32 p-4 -mt-20 ml-3 mb-2 text-white rounded-lg relative flex-no-shrink bg-tertiary mr-5">
          <icon name="remote_viewing"></icon>
        </div>
        <h1 class="font-semibold">My Remote Viewings</h1>
      </div>
    </div><!-- header end -->

    <div class="w-full flex items-center border-b pb-4">
      <div class="w-full max-w-xs flex flex-col mr-5">
        <label class="mb-1 text-xs">Search:</label>
        <div class="max-w-sm w-full border flex items-center border-grey-dark rounded p-2">
          <icon name="magnify_glass" :center="false" class="text-grey-dark w-8 h-8" />
          <input class="w-full" placeholder="Postcode, Town, Village..." v-model="searchTerm" />
        </div>
      </div>

      <div class="mt-4 mr-5">
        <input type="radio" class="blue" id="future-viewings" value="future" v-model="dateIn">
        <label for="future-viewings" class="text-sm">Future Viewings</label>
      </div>

      <div class="mt-4">
        <input type="radio" class="blue" id="past-viewings" value="past" v-model="dateIn">
        <label for="past-viewings" class="text-sm">Past Viewings</label>
      </div>
    </div>

    <div class="w-full flex items-center">
      <table class="w-full">
        <thead class="border-b">
          <tr>
            <td class="py-6 text-xs font-semibold uppercase"></td>
            <td class="py-6 text-xs font-semibold uppercase">Address</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Price</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Viewing Date</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Host</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Attendees</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Meeting Link</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Details</td>
            <td class="py-6 text-xs font-semibold uppercase text-center">Cancel</td>
          </tr>
        </thead>
        <tbody v-if="loading" >
          <tr>
            <td class="py-6 text-xs text-center" colspan="9">
              <loader/>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="viewings.length === 0">
          <tr>
            <td class="py-6 text-xs text-center" colspan="9">
              No Results
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="viewing in viewings" :key="viewing.id" class="border-b">
            <td class="py-6 text-sm uppercase">
              <div class="flex items-center">
                <div
                  class="w-16 h-10 bg-cover mr-3"
                  :style="{'background-image': `url(${viewing.prime_property.image})`}"
                />
              </div>
            </td>
            <td class="py-6 text-sm">
              <div class="flex flex-col">
                <span class="mb-1 w-48">{{ viewing.prime_property.address }}</span>
                <span v-if="viewing.property_count > 0" class="text-xs text-grey-dark">+ {{ viewing.property_count }} other properties</span>
              </div>
            </td>
            <td class="py-6 text-sm text-center">
              {{ viewing.prime_property.price }}
            </td>
            <td class="py-6 text-sm text-center">
              <div class="flex flex-col">
                <span class="text-green font-semibold mb-1">{{ moment(viewing.appointment_at).format('D MMMM YYYY') }}</span>
                <span class="text-xs text-green">{{ viewing.appointment_time_range }}</span>
              </div>
            </td>
            <td class="py-6 text-sm text-center">
              {{ viewing.host.name }}
            </td>
            <td class="py-6 text-sm text-center font-bold">
              x{{ viewing.applicant_count }}
            </td>
            <td class="py-6 text-xs text-center">
              <div class="flex flex-col">
                <a :href="viewing.meeting_url" target="_blank" class="mb-2 text-tertiary">{{ truncate(viewing.meeting_url || '', 25) }}</a>
                <copy-link class="w-full" :link="viewing.meeting_url">
                  <span class="flex justify-center items-center text-green cursor-pointer">
                    <span class="flex border-b border-green pb-px">
                      <icon name="link" class="w-3 h-3 mr-1" :center="false" /> Copy link
                    </span>
                  </span>
                </copy-link>
              </div>
            </td>
            <td class="py-6 text-sm uppercase">
              <div @click="openViewingDetails(viewing)" class="flex justify-center cursor-pointer">
                <icon name="remote_viewing" class="w-8 h-8 text-green" :center="false" />
              </div>
            </td>
            <td class="py-6 text-sm uppercase">
              <div @click="openCancelViewing(viewing)" class="flex justify-center cursor-pointer">
                <icon name="delete" class="w-8 h-8" :center="false" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal
      v-if="showViewingDetails"
      width="1000px"
      height="700px"
      :showCloseBtn="true"
      @leave="closeModal"
    >
      <div class="p-5">
        <div class="flex flex-col mb-12">
          <h1 class="text-base font-semibold mb-2">Remove viewing details</h1>
          <p class="text-sm">Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos vero exercitationem commodi excepturi aliquam, quos, molestias aut porro corrupti adipisci, nobis error magni? Deserunt illum ut, tenetur in quibusdam minima?</p>
        </div>

        <div class="flex">
          <div class="w-full flex flex-col mr-6">
            <div class="flex items-center pb-3 border-b border-tertiary mb-4">
              <icon name="remote_viewing" :center="false" class="w-8 h-8 mr-3 text-tertiary" />
              <span class="">Viewing Details</span>
            </div>
            <viewing-details :viewing="selectedViewing" class="mb-6" />
          </div>

          <div class="h-120 w-full flex flex-col mr-6">
            <div class="flex items-center pb-3 border-b border-tertiary mb-4">
              <icon name="user" :center="false" class="w-8 h-8 mr-3 text-tertiary" />
              <span class="">Attendees</span>
            </div>
            <loader v-if="viewingLoading" />
            <div class="text-sm text-center" v-else-if="unableToFetchViewing">
              Unable to fetch attendees.
            </div>
            <div v-else class="h-full overflow-y-scroll">
              <applicant-list :applicants="viewingApplicants" />
            </div>
          </div>

          <div class="w-full flex flex-col">
            <div class="flex items-center pb-3 border-b border-tertiary mb-4">
              <icon name="properties" :center="false" class="w-8 h-8 mr-3 text-tertiary" />
              <span class="">Properties</span>
            </div>
            <loader v-if="viewingLoading" />
            <div class="text-sm text-center" v-else-if="unableToFetchViewing">
              Unable to fetch properties.
            </div>
            <div v-else class="h-full overflow-y-scroll">
              <property-list :primeSelector="false" :primeProperty="viewingPrimeProperty" :properties="viewingProperties" />
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal
      v-if="showCancelViewing"
      width="700px"
      height="600px"
      :showCloseBtn="true"
      @leave="closeModal"
    >
      <div class="flex flex-col mb-12 text-center">
        <h1 class="text-base font-semibold mb-2">You are about to cancel the remote viewing for:</h1>
      </div>
      <div class="flex flex-col items-center">
        <div class="w-full flex mb-6">
          <div class="w-full flex flex-col mr-6">
            <div class="flex items-center pb-3 border-b border-tertiary mb-4">
              <icon name="remote_viewing" :center="false" class="w-8 h-8 mr-3 text-tertiary" />
              <span>Viewing Details</span>
            </div>
            <viewing-details :viewing="selectedViewing" class="mb-6" />
          </div>

          <div class="w-full flex flex-col mr-6">
            <div class="flex items-center pb-3 border-b border-tertiary mb-4">
              <icon name="user" :center="false" class="w-8 h-8 mr-3 text-tertiary" />
              <span>Attendees</span>
            </div>
            <loader v-if="viewingLoading" />
            <div class="text-sm text-center" v-else-if="unableToFetchViewing">
              Unable to fetch attendees.
            </div>
            <div v-else class="h-full overflow-y-scroll">
              <applicant-list :applicants="viewingApplicants" />
            </div>
          </div>
        </div>

        <button @click="cancelViewing" class="px-5 py-3 flex items-center bg-grey-light justify-center rounded-lg hover:bg-grey">
          <loader v-if="cancelling" />
          <template v-else>
            <icon name="delete" :center="false" class="text-grey-darker w-6 h-6 mr-2" />
            <span class="font-semibold text-grey-darker uppercase text-sm">Cancel Viewing</span>
          </template>
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import api from '@/http'
import Calendar from '@/components/SmartViewing/Calendar'
import PropertyList from '@/components/SmartViewing/PropertyList'
import ViewingDetails from '@/components/SmartViewing/ViewingDetails'
import ApplicantList from '@/components/SmartViewing/ApplicantList'
import CopyLink from '@/components/CopyLink'
import moment from 'moment'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import { truncate } from '@/helpers'

export default {
  name: 'Viewings',

  components: {
    Calendar,
    PropertyList,
    ViewingDetails,
    ApplicantList,
    CopyLink
  },

  data () {
    return {
      selectedViewing: null,
      showViewingDetails: false,
      showCancelViewing: false,
      viewingLoading: false,
      showCancellation: false,
      unableToFetchViewing: false,
      cancelling: false,
      viewingPrimeProperty: null,
      viewingProperties: [],
      searchTerm: '',
      dateIn: 'future',
      date: moment().local(),
      loading: false,
      viewings: [],
      viewingApplicants: []
    }
  },

  computed: {
    ...mapState(['selectedOffice'])
  },

  mounted () {
    this.fetchViewings()
  },

  methods: {
    openViewingDetails (viewing) {
      this.selectedViewing = viewing
      this.showViewingDetails = true
    },

    openCancelViewing (viewing) {
      this.selectedViewing = viewing
      this.showCancelViewing = true
    },

    closeModal () {
      this.selectedViewing = null
      this.showViewingDetails = false
      this.showCancelViewing = false
    },

    fetchViewings () {
      this.loading = true
      api.get('smart-viewing/my-viewings', {
        params: {
          office_id: this.selectedOffice.id,
          search: this.searchTerm,
          date_in: this.dateIn
        }
      }).then(({ data }) => {
        this.viewings = data
      }).finally(() => {
        this.loading = false
      })
    },

    fetchViewing () {
      this.viewingLoading = true
      this.unableToFetchViewing = false
      api.get(`smart-viewing/my-viewings/${this.selectedViewing.id}`)
        .then(({ data }) => {
          this.viewingProperties = data.viewing.properties
          this.viewingPrimeProperty = data.viewing.prime_property
          this.viewingApplicants = data.applicants
        }).catch(() => {
          this.unableToFetchViewing = true
        }).finally(() => {
          this.viewingLoading = false
        })
    },

    cancelViewing () {
      this.cancelling = true
      api.delete(`smart-viewing/my-viewings/${this.selectedViewing.id}`)
        .then(() => {
          this.closeModal()
          this.fetchViewings()
        }).finally(() => {
          this.cancelling = false
        })
    },

    moment,
    truncate
  },

  watch: {
    selectedViewing (value) {
      if (value) {
        this.fetchViewing()
      }
    },

    searchTerm: debounce(function () {
      this.fetchViewings()
    }, 200),

    dateIn: debounce(function () {
      this.fetchViewings()
    }, 200)
  }
}
</script>
